
import React from 'react';


export const attributes = {"name":"How To Access Crm","order":1};
export default function() {
  return (
    <div>
      <h2>HOW TO ACCESS THE CRM SYSTEM</h2>
<h3>Accessing CRM through your web browser</h3>
<p>To access Premiere through your web browser:</p>
<ul>
<li>Go to <a href="https://dynamics.premieresuites.com">https://dynamics.premieresuites.com</a> for the live site or <a href="https://crmstaging.premieresuites.com">https://crmstaging.premieresuites.com</a> for learning, testing and training</li>
<li>Login using your username (usually your Premiere email address) and the password provided to you by your manager</li>
</ul>
<p><strong>Important Note - All users have one account for email and CRM.</strong> The user login systems for email and CRM are integrated. If you forget your CRM password and it must be reset, this will also reset your email password. Please contact support@premieresuites.com for further assistance</p>

    </div>
  );
};


// WEBPACK FOOTER //
// ../content/pages/getting-started/how-to-access-crm.md